import React from "react";
import classnames from "classnames";
import { usePagination, DOTS } from "./usePagination";

const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className,
    dotsLabel,
    ...restProps
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  const onNext = (event) => {
    event.preventDefault();
    if (currentPage < lastPage) {
      onPageChange(currentPage + 1);
    }
  };

  const onPrevious = (event) => {
    event.preventDefault();
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  let lastPage = paginationRange[paginationRange.length - 1];
  return (
    <ul className={classnames(className, restProps.containerClassName)}>
      <li
        className={classnames(restProps.previousLinkClassName, {
          [restProps.disabledLinkClassName]: currentPage === 1,
        })}
        onClick={onPrevious}
      >
        {restProps.previousLabel}
      </li>
      <li>
        <ul className={restProps.subContainerClassName}>
          {paginationRange.map((pageNumber, i) => {
            if (pageNumber === DOTS) {
              return (
                <li key={i} className={restProps.breakClassName}>
                  <button
                    type="button"
                    className={restProps.breakLinkClassName}
                  >
                    {restProps.breakLabel}
                  </button>
                </li>
              );
            }

            return (
              <li
                key={i}
                className={classnames(restProps.pageClassName, {
                  [restProps.activeClassName]: pageNumber === currentPage,
                })}
                onClick={() => onPageChange(pageNumber)}
              >
                <button
                  type="button"
                  className={classnames(restProps.pageLinkClassName, {
                    [restProps.activeLinkClassName]: pageNumber === currentPage,
                  })}
                >
                  {pageNumber}
                </button>
              </li>
            );
          })}
        </ul>
      </li>
      <li
        className={classnames(restProps.nextLinkClassName, {
          [restProps.disabledLinkClassName]: currentPage === lastPage,
        })}
        onClick={onNext}
      >
        {restProps.nextLabel}
      </li>
    </ul>
  );
};

export default Pagination;
